import { type ComponentPropsConfig } from '../../../utils/codegen';

export const componentPropsConfig: ComponentPropsConfig = {
	defaultValue: true,
	max: true,
	min: true,
	step: true,
	testId: true,
	onChange: true,
};

/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::12a3a52703a37e2449f92c5958b865c3>>
 * @codegenId #range
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen range
 * @codegenParams { "hasFieldProps": {"isRequired": false, "isInvalid": false, "onChange": false} }
 * @codegenDependency ../../../../../../../design-system/range/src/range.tsx <<SignedSource::15eea32f3992862e9188336e9c8f0f27>>
 * @codegenDependency ../../../../../../../design-system/range/src/styled.tsx <<SignedSource::47b14c57f636a050ff3d07851578e96c>>
 */
/* eslint @repo/internal/codegen/signed-source-integrity: "warn" */
import React from 'react';
import type { RenderFn } from '@atlassian/forge-ui-types';
import PlatformRange from '@atlaskit/range';
import { adaptEventHandler } from "../../../utils";
import type { EventHandlerProps } from "../../types";

type PlatformRangeProps = React.ComponentProps<typeof PlatformRange>;

export type RangeProps = Pick<
  PlatformRangeProps,
  'defaultValue' | 'max' | 'min' | 'step' | 'testId' | 'onChange'
 | 'id' | 'isDisabled' | 'value' | 'aria-invalid' | 'aria-labelledby' | 'name'
> & Pick<EventHandlerProps, 'onBlur' | 'onFocus'>;

/**
 * A range lets users choose an approximate value on a slider.
 */
export const Range = (props: Parameters<RenderFn>[0]): React.JSX.Element => {
  const {
    defaultValue,
    max,
    min,
    step,
    testId,
    onChange,
    // Field props
    id,
    isDisabled,
    onBlur,
    onFocus,
    value,
    "aria-invalid": ariaInvalid,
    "aria-labelledby": ariaLabelledby,
    name,
  } = props.forgeDoc.props as RangeProps;
  return (
    <PlatformRange
      defaultValue={defaultValue}
      max={max}
      min={min}
      step={step}
      testId={testId}
      onChange={onChange}
      // Field props
      id={id}
      isDisabled={isDisabled}
      onBlur={adaptEventHandler(onBlur)}
      onFocus={adaptEventHandler(onFocus)}
      value={value}
      aria-invalid={ariaInvalid}
      aria-labelledby={ariaLabelledby}
      name={name}
    />
  );
};
/**
 * @codegenEnd
 */
